export default Object.freeze({
  AWAITING_UPLOAD: 'AWAITING_UPLOAD',
  UPLOADING: 'UPLOADING',
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
});
